import { isIOS, isAndroid, ANDROID, IOS } from '../userAgent';

/**
 * Format the current flag for the platform recieved
 * @param {string} key
 * @param {string} platform
 * @returns string
 */
function formatKeyByPlatform(key, platform) {
  const replaceKey = isIOS(platform) || isAndroid(platform);
  const prefix = {
    [ANDROID]: 'and',
    [IOS]: 'ios',
  };
  return replaceKey ? key.replace(/mweb/, prefix[platform]) : key;
}

export default formatKeyByPlatform;
